import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  SsoAccountData,
  SessionStorageKey,
  SessionStorageState,
} from 'common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifp-setup-begin',
    templateUrl: './setup-begin.component.html',
    styleUrls: ['./setup-begin.component.scss'],
    standalone: false
})
export class SetupBeginComponent implements OnInit {
  data: SetupBeginComponentData;
  continueEnabled = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    ) {
    SessionStorageState.set(SessionStorageKey.AccountSetupViewed, true);
    SessionStorageState.set(SessionStorageKey.ApplicationAgreementViewed, true);
  }

  ngOnInit(): void {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((it: SetupBeginComponentData) => {
        this.data = it;
        this.handleIdVerseCompletedCallback();
      });
  }

  continue() {
    this.continueEnabled = false;
    this.router
      .navigate(['account', 'setup', 'verify-identity'], { replaceUrl: true })
      .finally(() => {
        this.continueEnabled = true;
      });
  }

  private handleIdVerseCompletedCallback(): void {
    if (SessionStorageState.get(SessionStorageKey.IdVerseCompletedCallback) !== true) {
      return;
    }

    this.continue();
  }
}

export interface SetupBeginComponentData {
  currentAccount: SsoAccountData;
}
